import React, { useState, useEffect } from 'react';
import PokemonCard from './PokemonCard';
import './TierSection.css';

const TIER_ORDER = ['S', 'A+', 'A', 'B+', 'B', 'C+'];

const CATEGORY_OPTIONS = [
  { value: 'all', label: 'All Pokémon' },
  { value: 'legendary', label: 'Legendary/Mythical Only' },
  { value: 'non-legendary', label: 'Non-Legendary/Mythical Only' }
];

function TierSection({ title, pokemons, onPokemonClick, selectedPokemon = [], getPokemonId, selectedTiers, categoryFilter, onCategoryChange, defaultCollapsed = false }) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  useEffect(() => {
    setCollapsed(defaultCollapsed);
  }, [defaultCollapsed]);

  if (!pokemons || pokemons.length === 0) {
    return (
      <div className="tier-section">
        <h2>{title}</h2>
        <p className="no-data">No Pokémon found for this category</p>
      </div>
    );
  }

  // Apply category filter if provided
  let filteredPokemons = pokemons;
  if (categoryFilter && categoryFilter !== 'all') {
    filteredPokemons = pokemons.filter(p =>
      categoryFilter === 'legendary' ? p.isLegendary : !p.isLegendary
    );
  }

  // Group pokemon by tier
  const tierGroups = {};
  const untiered = [];
  for (const pokemon of filteredPokemons) {
    const tier = pokemon.tier;
    if (tier && TIER_ORDER.includes(tier)) {
      if (!tierGroups[tier]) tierGroups[tier] = [];
      tierGroups[tier].push(pokemon);
    } else {
      untiered.push(pokemon);
    }
  }

  const renderCard = (pokemon) => {
    const pokemonId = getPokemonId ? getPokemonId(pokemon) : pokemon.rank;
    const isSelected = selectedPokemon.some(p => {
      const selectedId = getPokemonId ? getPokemonId(p) : p.rank;
      return selectedId === pokemonId;
    });
    return (
      <PokemonCard 
        key={pokemonId} 
        pokemon={pokemon}
        onClick={() => onPokemonClick && onPokemonClick(pokemon)}
        isSelected={isSelected}
      />
    );
  };

  const activeTiers = TIER_ORDER.filter(t => tierGroups[t] && (!selectedTiers || selectedTiers.includes(t)));
  const showUntiered = untiered.length > 0 && (!selectedTiers || selectedTiers.includes('Untiered'));

  return (
    <div className={`tier-section ${collapsed ? 'tier-section-collapsed' : ''}`}>
      <h2 className="tier-section-header" onClick={() => setCollapsed(c => !c)}>
        {title}
        <span className={`collapse-arrow ${collapsed ? 'collapsed' : ''}`}>▾</span>
      </h2>
      {!collapsed && onCategoryChange && (
        <div className="category-filter">
          {CATEGORY_OPTIONS.map(opt => (
            <button
              key={opt.value}
              className={`category-filter-btn ${categoryFilter === opt.value ? 'active' : ''}`}
              onClick={() => onCategoryChange(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
      {!collapsed && activeTiers.map(tier => (
        <div key={tier} className={`tier-group tier-${tier.replace('+', '-plus')}`}>
          <div className={`tier-label tier-label-${tier.replace('+', '-plus')}`}>
            {tier} Tier
          </div>
          <div className="pokemon-grid">
            {tierGroups[tier].map(renderCard)}
          </div>
        </div>
      ))}
      {!collapsed && showUntiered && (
        <div className="tier-group tier-untiered">
          <div className="tier-label tier-label-Untiered">Untiered</div>
          <div className="pokemon-grid">
            {untiered.map(renderCard)}
          </div>
        </div>
      )}
    </div>
  );
}

export default TierSection;
